<template>
    <div class="checkout-summary">
        <h4 class="block-title">Summary</h4>
        <!-- BIKES -->
        <div class="summary-list" v-if="bikes && bikes.length > 0">
            <div v-for="(bike, i) in bikes" :key="i" class="summary-block">
                <div class="summary-block-item main-item">
                    <div class="summary-block-item-title">{{ bike.item.type_name }} <span v-if="bike.amount > 1" class="text-primary">x{{ bike.amount }}</span></div>
                    <div v-if="bike.item.discount && !promoCode" class="summary-block-item-value has-discount">
                        <span class="old-price">{{ (bike.priceOption.price * bike.amount) | filterPrice }}</span><br>
                        {{ (bike.priceOption.final_price * bike.amount) | filterPrice }}
                    </div>
                    <div v-else class="summary-block-item-value" >
                        {{ (bike.priceOption.price * bike.amount) | filterPrice }}
                    </div>
                </div>
                <!-- insurance -->
                <div v-if="bike.insuranceAmount > 0" class="summary-block-item secondary-item">
                    <div class="summary-block-item-title ps-2">+ Insurance <span v-if="bike.insuranceAmount > 1" class="text-primary">x{{ bike.insuranceAmount }}</span></div>
                    <div class="summary-block-item-value">
                        {{ (bike.item.insurance * bike.insuranceAmount) | filterPrice }}
                    </div>
                </div>
            </div>
        </div>
        <!-- Events -->
        <div class="summary-list" v-if="events && events.length > 0">
            <div v-for="(bike, i) in events" :key="i" class="summary-block">
                <div class="summary-block-item main-item">
                    <div class="summary-block-item-title">{{ bike.item.type_name }} <span v-if="bike.amount > 1" class="text-primary">x{{ bike.amount }}</span></div>
                    <div v-if="bike.item.discount && !promoCode" class="summary-block-item-value has-discount">
                        <span class="old-price">{{ (bike.priceOption.price * bike.amount) | filterPrice }}</span><br>
                        {{ (bike.priceOption.final_price * bike.amount) | filterPrice }}
                    </div>
                    <div v-else class="summary-block-item-value" >
                        {{ (bike.priceOption.price * bike.amount) | filterPrice }}
                    </div>
                </div>
                <!-- insurance -->
                <div v-if="bike.insuranceAmount > 0" class="summary-block-item secondary-item">
                    <div class="summary-block-item-title ps-2">+ Insurance <span v-if="bike.insuranceAmount > 1" class="text-primary">x{{ bike.insuranceAmount }}</span></div>
                    <div class="summary-block-item-value">
                        {{ (bike.item.insurance * bike.insuranceAmount) | filterPrice }}
                    </div>
                </div>
            </div>
        </div>
        <!-- TOURS -->
        <div class="summary-list" v-if="tours && tours.length > 0">
            <div v-for="(tour, i) in tours" :key="i" class="summary-block">
                <div class="summary-block-item main-item">
                    <div class="summary-block-item-title">{{ tour.item.name }} <span v-if="tour.amount > 1" class="text-primary">x{{ tour.amount }}</span></div>
                    <div v-if="tour.item.discount && !promoCode" class="summary-block-item-value has-discount">
                        <span class="old-price">{{ (tour.item.price * tour.amount) | filterPrice }}</span><br>
                        {{ (tour.item.final_price * tour.amount) | filterPrice }}
                    </div>
                    <div class="summary-block-item-value" v-else>
                        {{ (tour.item.price * tour.amount) | filterPrice }}
                    </div>
                </div>
                <div v-if="bike.insuranceAmount > 0" v-for="(bike, index) in tour.item.bike_types" :key="index"  class="summary-block-item secondary-item">
                    <div class="summary-block-item-title ps-2">+ Insurance <span v-if="bike.insuranceAmount > 1" class="text-primary">x{{ bike.insuranceAmount }}</span></div>
                    <div class="summary-block-item-value">
                        {{ (bike.bike_type.insurance * bike.insuranceAmount) | filterPrice }}
                    </div>
                </div>
            </div>
        </div>
        <!-- ACCESSORIES -->
        <div class="summary-list" v-if="accessories && accessories.length > 0">
            <div v-for="(accessory, i) in accessories" :key="i" class="summary-block">
                <div class="summary-block-item main-item">
                    <div class="summary-block-item-title">{{ accessory.item.name }} <span v-if="accessory.amount > 1" class="text-primary">x{{ accessory.amount }}</span></div>
                    <div class="summary-block-item-value">{{ (accessory.priceOption.price * accessory.amount) | filterPrice }}</div>
                </div>
            </div>
        </div>
        <!-- MERCHANDISES -->
        <div class="summary-list" v-if="merchandises && merchandises.length > 0">
            <div v-for="(merchandise, i) in merchandises" :key="i" class="summary-block">
                <div class="summary-block-item main-item">
                    <div class="summary-block-item-title">{{ merchandise.item.name }} ({{ merchandise.priceOption.size }}) <span v-if="merchandise.amount > 1" class="text-primary">x{{ merchandise.amount }}</span></div>
                    <div class="summary-block-item-value">{{ (merchandise.priceOption.price * merchandise.amount) | filterPrice }}</div>
                </div>
            </div>
        </div>
        <!-- OPTIONS -->
        <div class="summary-list" v-if="additionalOptions && additionalOptions.length > 0">
            <div v-for="(option, i) in additionalOptions" :key="i" class="summary-block">
                <div class="summary-block-item main-item">
                    <div class="summary-block-item-title">{{ option.item.name }} <span v-if="option.amount > 1" class="text-primary">x{{ option.amount }}</span></div>
                    <div class="summary-block-item-value">{{ (option.item.additional_option_location_prices.price * option.amount) | filterPrice }}</div>
                </div>
            </div>
        </div>
        <div class="summary-total">
            <div class="summary-block">
                <div class="summary-block-item secondary-item">
                    <div class="summary-block-item-title">Subtotal</div>
                    <div class="summary-block-item-value">{{ totalPrice | filterPrice }}</div>
                </div>
                <div class="summary-block-item secondary-item">
                    <div class="summary-block-item-title">Tax</div>
                    <div class="summary-block-item-value">{{ totalTax | filterPrice }}</div>
                </div>
                <div class="summary-block-item secondary-item" v-if="surgeCharge > 0">
                    <div class="summary-block-item-title">Surge charge</div>
                    <div class="summary-block-item-value">{{ surgeCharge | filterPrice }}</div>
                </div>
                <div class="summary-block-item secondary-item" v-if="fee > 0">
                    <div class="summary-block-item-title">Transaction fee ({{fee}}%)</div>
                    <div class="summary-block-item-value">{{ ((totalPrice + totalTax - totalDiscount + surgeCharge) * feeFloat ) | filterPrice }}</div>
                </div>
                <div v-if="promoCode" class="summary-block-item secondary-item">
                    <div class="summary-block-item-title">
                        Code [<span class="text-primary">{{ promoCode.code }}</span>]
                        <span v-if="!showAndClear" class="bi bi-x-circle text-danger ms-2 clear-discount" @click="clearPromoCode"></span>
                    </div>
                    <div class="summary-block-item-value">-{{ totalDiscount | filterPrice }}</div>
                </div>
                <div class="summary-block-item colored-item">
                    <div class="summary-block-item-title">Total</div>
                    <div class="summary-block-item-value">{{ (totalPrice + totalTax - totalDiscount + surgeCharge) + ((totalPrice + totalTax - totalDiscount + surgeCharge) * feeFloat ) | filterPrice }}</div>
                </div>
            </div>
            <slot v-if="!isEmpty"></slot>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "CheckoutSummary",
    props: {
        showAndClear: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            savedCartState: {},
            ready: false
        }
    },
    computed: {
        bikes: function () {
            return this.showAndClear ? this.savedCartState.bikes : this.$store.getters['cart/bikes']
        },
        events: function () {
            return this.showAndClear ? this.savedCartState.events : this.$store.getters['cart/events']
        },
        tours: function () {
            return this.showAndClear ? this.savedCartState.tours : this.$store.getters['cart/tours']
        },
        accessories: function () {
            return this.showAndClear ? this.savedCartState.accessories : this.$store.getters['cart/accessories']
        },
        merchandises: function () {
            return this.showAndClear ? this.savedCartState.merchandises : this.$store.getters['cart/merchandises']
        },
        additionalOptions: function () {
            return this.showAndClear ? this.savedCartState.additionalOptions : this.$store.getters['cart/additionalOptions']
        },
        totalPrice: function () {
            return this.showAndClear ? this.savedCartState.totalPrice : this.$store.getters['cart/totalPrice']
        },
        totalTax: function () {
            return this.showAndClear ? this.savedCartState.totalTax : this.$store.getters['cart/totalTax']
        },
        isEmpty: function () {
            return this.showAndClear ? this.savedCartState.isEmpty : this.$store.getters['cart/isEmpty']
        },
        promoCode: function () {
            return this.showAndClear ? this.savedCartState.promoCode : this.$store.getters['cart/promoCode']
        },
        totalDiscount: function () {
            return this.showAndClear ? this.savedCartState.totalDiscount : this.$store.getters['cart/totalDiscount']
        },
        fee: function () {
            const locations = this.$store.getters['app/locations'];
            const filterLocation = this.$store.getters['filter/rentLocation'];
            const location = locations.find(location => location.id === parseInt(filterLocation));

            if(location) {
                return location.fee !== undefined ? parseFloat(location.fee) : 0;
            }
            const settings = this.$store.getters['app/settings'];
            return settings.location !== undefined && settings.location.fee !== undefined ? parseFloat(settings.location.fee) : 0;
        },
        feeFloat: function () {
            const locations = this.$store.getters['app/locations'];
            const filterLocation = this.$store.getters['filter/rentLocation'];
            const location = locations.find(location => location.id === parseInt(filterLocation));

            if(location) {
                return location.fee !== undefined ? parseFloat(location.fee)/100 : 0;
            }
            const settings = this.$store.getters['app/settings'];
            return settings.location !== undefined && settings.location.fee !== undefined ? parseFloat(settings.location.fee)/100 : 0;
        },
        surgeCharge: function () {
            const locations = this.$store.getters['app/locations'];
            let bikesAmount = 0;
            let surge_charge = 0;

            const filterLocation = this.$store.getters['filter/rentLocation'];
            const location = locations.find(location => location.id === filterLocation);

            if(location) {
                surge_charge = location.surge_charge !== undefined ? parseInt(location.surge_charge) : 0;
            }

            if(this.bikes && Array.isArray(this.bikes) && this.bikes.length > 0) {
                this.bikes.forEach(bike => {
                    if(bike.enableSurgeCharge) {
                        bikesAmount += parseInt(bike.amount);
                    }
                })

                return surge_charge * bikesAmount;
            }
            return 0;
        },
    },
    mounted() {
        this.cloneCartState();
        if (this.showAndClear) {
            this.$store.dispatch('cart/clear');
        }
    },
    methods: {
        ...mapActions('cart', ['clearPromoCode']),
        ...mapGetters('app', ['settings']),
        cloneCartState() {
            this.savedCartState = {
                bikes: this.$store.getters['cart/bikes'],
                events: this.$store.getters['cart/events'],
                tours: this.$store.getters['cart/tours'],
                accessories: this.$store.getters['cart/accessories'],
                merchandises: this.$store.getters['cart/merchandises'],
                additionalOptions: this.$store.getters['cart/additionalOptions'],
                totalPrice: this.$store.getters['cart/totalPrice'],
                totalTax: this.$store.getters['cart/totalTax'],
                isEmpty: this.$store.getters['cart/isEmpty'],
                promoCode: this.$store.getters['cart/promoCode'],
                totalDiscount: this.$store.getters['cart/totalDiscount']
            }
        }
    }
}
</script>

<style scoped>

</style>
